import {
  Feature,
  isFeatureEnabled,
} from '../../../../../../config/FeaturesConfig';
import { SUBMETRIC_FONT_SIZE, SUBMETRIC_ROW_WIDTHS } from '../../helper';
import React from 'react';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { FormattedMessage } from 'react-intl';

const NoSubMetric: React.FC = () => {
  return (
    <Column spacing='none' width='100%'>
      <Row
        alignmentVertical='top'
        width='100%'
        widths={SUBMETRIC_ROW_WIDTHS}
        spacing='none'
      >
        <Text type={SUBMETRIC_FONT_SIZE}>
          <FormattedMessage
            id='cs_perfportal_lighthouse_noSubmetrics'
            defaultMessage='No sub metric data to report'
          />
        </Text>
        <Text type={SUBMETRIC_FONT_SIZE}>--</Text>
        <Text type={SUBMETRIC_FONT_SIZE}>--</Text>
      </Row>
    </Column>
  );
};

export default NoSubMetric;
